import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { editReportVersionRoute, editReportVersionEngagementOverviewRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { ReportVersionStatus, useReportVersionEngagementOverviewQuery } from "app/api/graph/types";
import { reportVersionGraphId } from "app/api/graph/helpers";
import { EditReportEngagementOverviewForm } from "app/component/report-engagement-overview/EditReportEngagementOverviewForm";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";

export const EditReportVersionEngagementOverviewScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(editReportVersionEngagementOverviewRoute);
    const [updated, setUpdated] = useState(false);
    const { data, loading, error } = useReportVersionEngagementOverviewQuery({
        variables: { versionId: reportVersionGraphId(versionId) },
    });
    const engagementOverview = data?.reportVersion?.engagementOverview;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!engagementOverview) {
        return <ErrorScreen title="Error" message="Not found" />;
    }
    if (data?.reportVersion?.status !== ReportVersionStatus.Scoping) {
        return <ErrorScreen title="Error" message="This section may only be edited during the scoping status." />;
    }

    return updated ? (
        <Navigate to={editReportVersionRoute.build({ reportId, versionId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={editReportVersionEngagementOverviewRoute} />
                <EditReportEngagementOverviewForm
                    engagementOverviewId={engagementOverview._id}
                    onUpdate={() => setUpdated(true)}
                />
            </Container>
        </NavigationScreen>
    );
};
